export default __webpack_public_path__ + "static/media/github-icon.a2eafb2a.svg";